export const uiStrings = {
  de: {
    heading: 'Projekte & Leistungen',
    subtitle: 'Tech-Unternehmer',
    viewProject: 'Projekt ansehen',
    detailAria: 'im Detail ansehen',
    allProjects: 'Alle Projekte',
    role: 'Rolle',
    technologies: 'Technologien',
    website: 'Webseite',
    visit: 'Projekt besuchen',
    download: 'Download',
    services: 'Leistungen im Projekt',
    next: 'Nächstes Projekt'
  },
  en: {
    heading: 'Projects & Services',
    subtitle: 'Tech Entrepreneur',
    viewProject: 'View project',
    detailAria: 'view details',
    allProjects: 'All projects',
    role: 'Role',
    technologies: 'Technologies',
    website: 'Website',
    visit: 'Visit project',
    download: 'Download',
    services: 'Project scope',
    next: 'Next project'
  },
  tr: {
    heading: 'Projeler & Hizmetler',
    subtitle: 'Teknoloji Girişimcisi',
    viewProject: 'Projeyi gör',
    detailAria: 'ayrıntılarını gör',
    allProjects: 'Tüm projeler',
    role: 'Rol',
    technologies: 'Teknolojiler',
    website: 'Web sitesi',
    visit: 'Projeyi ziyaret et',
    download: 'İndir',
    services: 'Proje kapsamı',
    next: 'Sonraki proje'
  }
};

export const projectTranslations = {
  en: {
    chargenest: {
      status: 'Live',
      role: 'Founder & Operator',
      category: 'Hardware & Platform',
      summary:
        'Power bank rental stations with proprietary hardware infrastructure and a digital platform for seamless borrowing.',
      description:
        'ChargeNest connects physical power bank stations with a digital platform. Users can easily borrow a power bank on the go and return it at any participating station.',
      services: [
        'Business model concept',
        'Building the hardware infrastructure',
        'Developing the digital platform',
        'Operation and further development'
      ],
      technologies: ['IoT', 'Web platform', 'Payment systems', 'Hardware']
    },
    donabox: {
      status: 'Live',
      role: 'Founder & Developer',
      category: 'FinTech & Hardware',
      summary:
        'Hardware and software solution for digital donations with direct forwarding of the funds.',
      description:
        'Donabox enables digital donations via modern stations. Communities and organizations receive the donations directly, while the system is financed solely through use of the accompanying application.',
      services: [
        'Product and hardware concept',
        'Developing the software solution',
        'User-friendly donation process',
        'Operation and further development'
      ],
      technologies: ['App development', 'Hardware', 'Payment', 'Cloud']
    },
    zutatenlupe: {
      status: 'Live on Google Play',
      role: 'App Development',
      category: 'Mobile Application',
      storeNote: 'The Apple App Store is coming soon.',
      summary:
        'Mobile app for fast and understandable analysis of ingredients in food.',
      description:
        'Zutatenlupe makes complex ingredient lists understandable. The app helps users grasp ingredients quickly and make informed decisions when grocery shopping. It is already available on Google Play, the Apple App Store follows soon.',
      services: [
        'User flow concept',
        'Developing the mobile application',
        'Preparing complex product data',
        'Release on Google Play, App Store to follow'
      ],
      technologies: ['iOS', 'Android', 'Mobile UX', 'Product analysis']
    },
    'pv-netzplaner': {
      status: 'Beta',
      role: 'Web Development',
      category: 'Planning Software',
      summary:
        'Digital planning tool for photovoltaic systems with an efficient and clear workflow.',
      description:
        'The PV-Netzplaner supports the structured planning of photovoltaic systems. The web application bundles the relevant planning steps in a clear interface and is currently released as a beta version.',
      services: [
        'Web application concept',
        'Developing the planning tool',
        'Optimizing the user interface',
        'Integration of payment options'
      ],
      technologies: ['React', 'Web application', 'Photovoltaics', 'Payment']
    },
    'ki-telefonassistenten': {
      title: 'AI Phone Assistants',
      status: 'Service',
      role: 'AI Integration',
      category: 'Artificial Intelligence',
      summary:
        'Intelligent phone assistants for automated customer service and better availability.',
      description:
        'Custom-built AI phone assistants handle recurring calls, answer common questions and help companies process incoming calls reliably.',
      services: [
        'Analysis of existing phone processes',
        'Designing custom conversation flows',
        'Integration into existing systems',
        'Optimization and ongoing support'
      ],
      technologies: ['Voice AI', 'Automation', 'API integration', 'Telephony']
    },
    'elektro-solar-webentwicklung': {
      title: 'Electrical, Solar & Web Development',
      status: 'Service',
      role: 'Full-Service Provider',
      category: 'Technical Services',
      summary:
        'Holistic solutions from electrical and solar engineering to custom websites and apps.',
      description:
        'Technical projects are implemented holistically: from the physical electrical and solar infrastructure to the matching digital solution. This creates coordinated systems from a single source.',
      services: [
        'Professional electrical work',
        'Solar system installation',
        'Developing custom websites',
        'Building tailor-made apps'
      ],
      technologies: [
        'Electrical engineering',
        'Photovoltaics',
        'Web development',
        'Apps'
      ]
    }
  },
  tr: {
    chargenest: {
      status: 'Yayında',
      role: 'Kurucu & İşletmeci',
      category: 'Donanım & Platform',
      summary:
        'Kendi donanım altyapısı ve sorunsuz kiralama için dijital platform sunan powerbank kiralama istasyonları.',
      description:
        'ChargeNest, fiziksel powerbank istasyonlarını dijital bir platformla birleştirir. Kullanıcılar yolda kolayca powerbank kiralayabilir ve katılımcı herhangi bir istasyonda iade edebilir.',
      services: [
        'İş modeli konsepti',
        'Donanım altyapısının kurulması',
        'Dijital platformun geliştirilmesi',
        'İşletme ve sürekli geliştirme'
      ],
      technologies: ['IoT', 'Web platformu', 'Ödeme sistemleri', 'Donanım']
    },
    donabox: {
      status: 'Yayında',
      role: 'Kurucu & Geliştirici',
      category: 'FinTech & Donanım',
      summary:
        'Bağışların doğrudan iletildiği dijital bağış toplama için donanım ve yazılım çözümü.',
      description:
        'Donabox, modern istasyonlar üzerinden dijital bağış yapılmasını sağlar. Cemaatler ve kuruluşlar bağışları doğrudan alır; sistemin finansmanı yalnızca ilgili uygulamanın kullanımıyla sağlanır.',
      services: [
        'Ürün ve donanım konsepti',
        'Yazılım çözümünün geliştirilmesi',
        'Kullanıcı dostu bağış süreci',
        'İşletme ve sürekli geliştirme'
      ],
      technologies: ['Uygulama geliştirme', 'Donanım', 'Ödeme', 'Bulut']
    },
    zutatenlupe: {
      status: 'Google Play’de yayında',
      role: 'Uygulama Geliştirme',
      category: 'Mobil Uygulama',
      storeNote: 'Apple App Store yakında geliyor.',
      summary:
        'Gıdalardaki içerik maddelerini hızlı ve anlaşılır biçimde analiz eden mobil uygulama.',
      description:
        'Zutatenlupe karmaşık içerik listelerini anlaşılır kılar. Uygulama, kullanıcıların içerikleri hızla kavramasına ve market alışverişinde bilinçli kararlar vermesine yardımcı olur. Google Play’de zaten mevcut, Apple App Store yakında geliyor.',
      services: [
        'Kullanıcı akışı konsepti',
        'Mobil uygulamanın geliştirilmesi',
        'Karmaşık ürün verilerinin hazırlanması',
        'Google Play’de yayın, App Store yakında'
      ],
      technologies: ['iOS', 'Android', 'Mobil UX', 'Ürün analizi']
    },
    'pv-netzplaner': {
      status: 'Beta',
      role: 'Web Geliştirme',
      category: 'Planlama Yazılımı',
      summary:
        'Verimli ve anlaşılır bir iş akışı sunan fotovoltaik sistemler için dijital planlama aracı.',
      description:
        'PV-Netzplaner, fotovoltaik sistemlerin yapılandırılmış planlamasını destekler. Web uygulaması ilgili planlama adımlarını net bir arayüzde toplar ve şu anda beta sürümü olarak yayındadır.',
      services: [
        'Web uygulaması konsepti',
        'Planlama aracının geliştirilmesi',
        'Kullanıcı arayüzünün optimizasyonu',
        'Ödeme seçeneklerinin entegrasyonu'
      ],
      technologies: ['React', 'Web uygulaması', 'Fotovoltaik', 'Ödeme']
    },
    'ki-telefonassistenten': {
      title: 'Yapay Zekâ Telefon Asistanları',
      status: 'Hizmet',
      role: 'Yapay Zekâ Entegrasyonu',
      category: 'Yapay Zekâ',
      summary:
        'Otomatik müşteri hizmeti ve daha iyi erişilebilirlik için akıllı telefon asistanları.',
      description:
        'Size özel geliştirilen yapay zekâ telefon asistanları tekrarlayan görüşmeleri üstlenir, sık sorulan soruları yanıtlar ve şirketlere gelen aramaları güvenilir şekilde işlemede destek olur.',
      services: [
        'Mevcut telefon süreçlerinin analizi',
        'Özel görüşme akışlarının tasarımı',
        'Mevcut sistemlere entegrasyon',
        'Optimizasyon ve sürekli destek'
      ],
      technologies: ['Ses yapay zekâsı', 'Otomasyon', 'API entegrasyonu', 'Telefon']
    },
    'elektro-solar-webentwicklung': {
      title: 'Elektrik, Güneş Enerjisi & Web Geliştirme',
      status: 'Hizmet',
      role: 'Bütünsel Hizmet',
      category: 'Teknik Hizmetler',
      summary:
        'Elektrik ve güneş enerjisi tekniğinden özel web sitelerine ve uygulamalara kadar bütünsel çözümler.',
      description:
        'Teknik projeler bütünsel olarak hayata geçirilir: fiziksel elektrik ve güneş enerjisi altyapısından uygun dijital çözüme kadar. Böylece tek elden uyumlu sistemler ortaya çıkar.',
      services: [
        'Uzman elektrik işleri',
        'Güneş enerjisi sistemi kurulumu',
        'Özel web sitelerinin geliştirilmesi',
        'Ihtiyaca özel uygulamaların hayata geçirilmesi'
      ],
      technologies: [
        'Elektrik tekniği',
        'Fotovoltaik',
        'Web geliştirme',
        'Uygulamalar'
      ]
    }
  }
};
